<template>
    <div  class="header-top">
        <!-- 顶部导航 -->
        <div class="header-top-logo">
          <img src="@/assets/images/hpcopy/logo.png" />
        </div>
        <div class="header-top-nav">
          <el-button class="kaitong" v-show="userInfo.supplier_is_vip!=1" @click="kaitong">开通会员</el-button>
          <!-- 用户 -->
            <el-dropdown @command="handleCommand">
              <div class="user">
                <el-avatar :src="userInfo.avatar"></el-avatar>
                <span>{{userInfo.nickname}}</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            userInfo:JSON.parse(localStorage.getItem('userInfo'))
        }
    },
    methods:{
      handleCommand(command) {
        if(command=='logOut'){
          this.LogOut()
        }
      },
      // 退出登录
      LogOut(){
        localStorage.removeItem("userInfo");
        localStorage.removeItem("isLogin");
        localStorage.removeItem("token");
        sessionStorage.removeItem('menu')
        sessionStorage.removeItem("has_password");
        this.isShowUser=false
        this.$message({
          type:'success',
          offset:80,
          message:'退出登录成功'
        })
        if (this.$route.path!='/index') {
          this.$router.push('/')
        }
      },
      kaitong(){
        if(this.$route.path != '/ht/member'){
          this.$router.push('/ht/member')
          sessionStorage.setItem("menu", '7-3');
        }
      }
    },
    mounted(){

    },
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>

.header-top {
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px;

  z-index: 9999;
  background: #FFFFFF;
  .header-top-logo {
    text-align: left;
    padding: 25px 0;
    img{
      width: 152px;
      height: 50px;
    }
  }

  .header-top-nav {
    display: flex;

    .kaitong{
      width: 100px;
      height: 38px;
      background: #EDF6FF;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      font-size: 16px;
      color: #0073F5;

      margin-right: 18px;
    }
    .user{
      display: flex;
      align-items: center;
      .el-avatar{
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }
      span{
        font-size: 16px;
        color: #666666;
      }
    }
  }
}
</style>